// extracted by mini-css-extract-plugin
module.exports = {"thankYouRow":"paymentSuccess-module--thank-you-row--KI9xQ","image":"paymentSuccess-module--image--2rwsK"};